import { BaseLayout } from '@components/Layout';
import {
  DistributorPage as DistributorPageComponent,
  getDistributorById,
  getDistributorBySlug,
  getDistributors,
} from '@milo/react';
import { Distributor } from '@milo/types';
import { GetStaticPaths, GetStaticProps, NextPage } from 'next';

export const getStaticPaths: GetStaticPaths = async () => {
  const distributors = await getDistributors();
  const paths = distributors.map((e: Distributor) => ({ params: { slug: e.slug.toLowerCase() } }));
  return {
    paths: paths,
    fallback: false,
  };
};

type DistributorPageProps = {
  distributor: Distributor;
};

const DistributorPage: NextPage<DistributorPageProps> = ({ distributor = {} as Distributor }) => {
  if (!distributor?.id) return null;

  return (
    <BaseLayout showBanner={false} showFooter={false} stickyNavigation>
      <DistributorPageComponent distributor={distributor} />
    </BaseLayout>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const params = context?.params;
    const slug = params?.slug as string;

    const getDistributorFn = slug.includes('dis_') ? getDistributorById : getDistributorBySlug;
    const distributor = await getDistributorFn(slug);

    if (!distributor?.id) {
      return { notFound: true };
    }

    return {
      props: {
        distributor,
        seo: {
          title: distributor.name,
          description: distributor.description,
          imagePath: distributor.image_url || '',
        },
      },
      revalidate: 30,
    };
  } catch (error) {
    return { notFound: true };
  }
};

export default DistributorPage;
